import script from "./DomainsList.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainsList.vue?vue&type=script&setup=true&lang=js"

import "./DomainsList.vue?vue&type=style&index=0&id=16338759&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16338759"]])

export default __exports__